import * as React from "react";
import Csrf from "../commons/model/Csrf";

interface CsrfInputProps {
  csrf: Csrf;
}

export default function CsrfInput({ csrf }: CsrfInputProps) {
  return <input type="hidden" name={csrf.parameter} value={csrf.token} />;
}
